import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';

// imported components
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OAuthModule } from 'angular-oauth2-oidc';
import { TegelModule } from '@scania/tegel-angular-17';

// components
import { AppComponent } from './app.component';
import { AppShellComponent } from './app-shell.component';
import {AlertComponent} from '../alert/alert.component'
import { HomeComponent } from '../home/home.component';
import { ConfigurationComponent } from '../configuration/configuration.component';
import { ChangesComponent } from '../changes/changes.component';
import { SelectConfigurationComponent } from '../selectconfiguration/selectconfiguration.component';
import { SignInComponent } from '../signin/signin.component';
import { SignOutComponent } from '../signout/signout.component';
import { ErrorComponent } from '../error/error.component';
import { UnauthorizedComponent } from '../unauthorized/unauthorized.component';
import { ProvisionComponent } from '../provision/provision.component';
import { SaveAsComponent } from '../saveas/saveas.component';
import { SuggestionComponent } from '../suggestion/suggestion.component';
import { AlternativeComponent } from '../alternative/alternative.component';
import { BreakdownSettingsComponent } from '../breakdownsettings/breakdownsettings.component';

// global services
import { UserService } from '../../services/user/user.service';
import { StructureService } from '../../services/structure/structure.service';
import { StateService } from '../../services/state/state.service';
import { SpecItemDescriptionService } from '../../services/specitemdescription/specitemdescription.service';
import { ExecutionService } from '../../services/execution/execution.service';
import { ErrorService } from '../../services/error/error.service';
import { ProvisionService } from 'src/services/provision/provision.service';
import { StateManagementService } from 'src/services/statemanagement/statemanagement.service';
import { AuthService } from '../../services/auth/auth.service';

// pipes
import { SearchProvisionItemsPipe } from '../../pipes/searchprovisionitems/searchprovisionitems.pipe';
import { SortRecommendedExecutionsPipe } from '../../pipes/sortrecommendedexecutions/sortrecommendedexecutions.pipe';
import { PadLeadingZerosPipe } from '../../pipes/padleadingzeros/padleadingzeros.pipe';
import { SortAddedFpcsPipe } from '../../pipes/sortchanges/sortaddedfpcs.pipe';
import { SortAdditionalChangesPipe } from '../../pipes/sortchanges/sortadditionalchanges.pipe';
import { SortChangesWithToAndFromExecutionsPipe } from '../../pipes/sortchanges/sortchangeswithtoandfromexecutions.pipe';
import { SortRemovedFpcsPipe } from '../../pipes/sortchanges/sortremovedfpcs.pipe';
import { SearchProvisionHeader } from '../../pipes/searchprovision/searchprovision.pipe';

// guards
import { AuthenticationGuard } from '../../guards/authentication.guard';

// interceptors
import { RequestInterceptor } from '../../interceptors/requestinterceptor';

const appRoutes: Routes = [
  {
    path: 'signin',
    component: SignInComponent
  },
  {
    path: 'signout',
    component: SignOutComponent
  },
  {
    path: '',
    canActivate: [AuthenticationGuard],
    component: HomeComponent
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: '**', 
    redirectTo: '/',
  }
];

@NgModule({
  declarations: [
    AppComponent,
    AppShellComponent,
    AlertComponent,
    HomeComponent,
    ChangesComponent,
    PadLeadingZerosPipe,
    SortAddedFpcsPipe,
    SortAdditionalChangesPipe,
    SortChangesWithToAndFromExecutionsPipe,
    SortRemovedFpcsPipe,
    ConfigurationComponent,
    SelectConfigurationComponent,
    SearchProvisionItemsPipe,
    SortRecommendedExecutionsPipe,
    ErrorComponent,
    UnauthorizedComponent,
    SignInComponent,
    SignOutComponent,
    SearchProvisionHeader,
    ProvisionComponent,
    SaveAsComponent,
    SuggestionComponent,
    AlternativeComponent,
    BreakdownSettingsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(appRoutes),
    OAuthModule.forRoot(),
    NgbModule,
    TegelModule,
  ],
  providers: [
    UserService,
    ErrorService,
    ExecutionService,
    SpecItemDescriptionService,
    StateService,
    StructureService,
    ProvisionService,
    StateManagementService,
    AuthService,
    provideHttpClient(withInterceptorsFromDi()),
    AuthenticationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true
    },
    provideAppInitializer(() => inject(AuthService).initAuth()),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
